import React ,{ useState, useEffect, useRef} from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Morningnote.css";
import Accordion from "react-bootstrap/Accordion";
import ResearchNotFOUND from "../../../Images/Images/5084996.png";
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState} from '../../features/User/UserSlice';
import { Helmet } from 'react-helmet-async';
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function Morningnote() {
    const[data,setData]=useState('');
    const[recentPost,setPost]=useState([]);
    const[PostData,setPostData]=useState([]);
    const[dateFormate,setDateformate]=useState('');
    const[title,setTitle]=useState('');
    const [show, setShow] = useState(false);
    const [metaData,setMetaData]=useState('')
    const [metaKeyword,setMetaKeyword]=useState('')
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const {isSuccess, isError} = useSelector(
        userSelector
    );
    useEffect(() => {
        if (isSuccess) {
            setShow(false);
        }
        if (isError) {
            dispatch(clearState());
        }
    }, [isSuccess, isError]);

    const clickToggleLoginPopup = (showhide) => {
        if (isSuccess) {
            window.open('/Products');
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }
	let pathName=window.location.pathname;
	var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    const dayname = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
 let researchPostRedirect=['/Research/market-hunt/','/Research/morning-note/','/Research/derivative-reports/','/Research/result-updates/','/Research/economy-updates/','/Research/ipo-coverage/','/Research/company-reports/','/Research/monthly-magazine/','/Research/metal-energy-watch/','/Research/other-reports/'];
    var para = pathName.split('/')[2];
       
        if(para == 'market-hunt') 
        para = 'morning-note'

	if(researchPostRedirect.includes(pathName))
		window.location="/Research/"+pathName.split('/')[2].replaceAll("/",'');
	useEffect(()=>{
	const  request={
		method:'post',
		headers: {
					  'Content-Type': 'application/json'
				   },
		body: JSON.stringify({'ctg':para})    
	  }
	  fetch('https://moneysukh.com:8443/recentPost',request)
	  .then(response=>{
		if(response.ok){
		  response.json().then(json=>{
			
			 if(json.results.length>0){
                recentpost();
                
				 if(researchPostRedirect.includes(pathName+"/" )){
                 setPostData(json.results[0]);
				 setDateformate(dayname[new Date(json.results[0].modified_date).getDay()]+","+json.results[0].modified_date.split('-')[2]+" "+months[json.results[0].modified_date.split('-')[1]-1]+" "+json.results[0].modified_date.split('-')[0])
			     setData(json.results[0].description);
                 setTitle(json.results[0].title)
                 setMetaData(json.results[0].meta_description)
                 setMetaKeyword(json.results[0].meta_keyword)
				 }
				 else{
					 recentPostData();
                     
				 }
			
			 }
			 else{
				 setData("Not Found");
			 }
			  
			
		  })
		}
	  })
	  .catch(e=>{
		//console.log(e);
	  })
	},[])

    const recentpost=()=>{
        const  request={
            method:'post',
            headers: {
                          'Content-Type': 'application/json'
                       },
           // body: JSON.stringify({'ctg':pathName.split('/')[1]})    
          }
          fetch('https://moneysukh.com:8443/recentPostData',request)
          .then(response=>{
            if(response.ok){
              response.json().then(json=>{
                 if(json.results.length>0){
                     
                //json.results.splice(4);
                setPost(json.results);
                 }
                 else{
                     setData("Not Found");
                 }
                  
                
              })
            }
          })
          .catch(e=>{
            //console.log(e);
          })
    }
	const recentPostData=()=>{
        const queryParams = new URLSearchParams(window.location.search);
const id = queryParams.get('id');

        const pathNamedecod=decodeURIComponent(pathName);
        
        let path= pathNamedecod.split('/')[3]!=undefined && pathNamedecod.split('/')[3].replaceAll("-"," ")
		const  request={
		method:'post',
		headers: {
					  'Content-Type': 'application/json'
				   },
		body: JSON.stringify({'ctg':pathNamedecod.split('/')[2],'meta_des':path,'id':id})    
	  }
		fetch('https://moneysukh.com:8443/getdata',request)
	  .then(response=>{
		if(response.ok){
		  response.json().then(json=>{
			 
			 if(json.results.length>0){
                console.log("aaaaaaa1111111111");
                setPostData(json.results[0]);
                setDateformate(dayname[new Date(json.results[0].modified_date).getDay()]+","+json.results[0].modified_date.split('-')[2]+" "+months[json.results[0].modified_date.split('-')[1]-1]+" "+json.results[0].modified_date.split('-')[0])
                setData(json.results[0].description);
                 setTitle(json.results[0].title);
                 setMetaData(json.results[0].meta_description)
                 setMetaKeyword(json.results[0].meta_keyword)
			 }
			 else{
                console.log("aaaaaaa111111111122");
				 setData("Not Found");
			 }
			  
			
		  })
		}
	  })
	  .catch(e=>{
		//console.log(e);
	  })
	}
  CallTrackApi("Commodity Reports",window.location.href);
    
    return (
        <>
        
        <Helmet>
         <title>{title}</title>
                <meta name='keywords' content={metaKeyword} />
                <meta name='description' content={metaData} />     
           

        </Helmet>
    

            {(data!='' & data!="Not Found") ? <><section className="researchsinglepage_header">
                <Container>
                    <Row className="align-items-center">
                        <Col xl={12} md={12} sm={12} xs={12}>
                            <div className="banner-left-pnl text-center">
                                <h1>{title}</h1>
                                <p className="post_date">{dateFormate}</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            
            <section className="researchsinglepage_bodysection py-5">
            
                <div className="container">
                    <div className="researchsinglepage_main">
                        <div className="row">
                            <div className="col-lg-8 col-md-12">
                             <div className="notes-body" dangerouslySetInnerHTML={{ __html:`${data}`}}/>
                               <section className="accordianmoningnote_main">
                                 
                                {(PostData.heading_1||PostData.heading_2||PostData.heading_3||PostData.heading_4||PostData.heading_5 )?<Accordion >
                                    { PostData.heading_1 ?<Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        {PostData.heading_1}
                                    </Accordion.Header>
                                        <Accordion.Body>
                                        <p dangerouslySetInnerHTML={{ __html:`${PostData.description_1}`}}/>
                                    </Accordion.Body>
                                    </Accordion.Item>:''}
                                    { PostData.heading_2 ?<Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        {PostData.heading_2}
                                    </Accordion.Header>
                                        <Accordion.Body>
                                        <p dangerouslySetInnerHTML={{ __html:`${PostData.description_2}`}}/>
                                    </Accordion.Body>
                                    </Accordion.Item>:''}
                                    { PostData.heading_3 ?<Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        {PostData.heading_3}
                                    </Accordion.Header>
                                        <Accordion.Body>
                                        <p className="tablegivecustomborder" dangerouslySetInnerHTML={{ __html:`${PostData.description_3}`}}/>
                                    </Accordion.Body>
                                    </Accordion.Item>:''}
                                    { PostData.heading_4 ?<Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        {PostData.heading_4}
                                    </Accordion.Header>
                                        <Accordion.Body>
                                        <p dangerouslySetInnerHTML={{ __html:`${PostData.description_4}`}}/>
                                    </Accordion.Body>
                                    </Accordion.Item>:''}
                                    { PostData.heading_5 ?<Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        {PostData.heading_5}
                                    </Accordion.Header>
                                        <Accordion.Body>
                                        <p dangerouslySetInnerHTML={{ __html:`${PostData.description_5}`}}/>
                                    </Accordion.Body>
                                    </Accordion.Item>:''}
                                     
                                 </Accordion>:''}
                            
                         </section>
                            </div>
                            <div className="col-lg-4 col-md-12">
                                <div className="researchsinglepage_sidebar sticky_panel">
                                    <div className="researchsinglepage_sidebargrid">
                                        <div className="rechrsnglsidebar_pricegrid">
                                            {/* <h2>We won't let your Margin sit idle.</h2> */}
                                            <div className="rechrsnglsidebar_pricegroup mt-4 d-flex justify-content-between">
                                                <div className="marginprice_box marginprice_20box">
                                                    <h3><i className="fa fa-rupee"></i><span>20</span><span className="rechrsnglsidebar_plan">
                                                        <small>Plan</small> A</span></h3><p>Per order + Zero delivery Brokerage</p>
                                                </div>
                                                <div className="marginprice_box marginprice_10box"><h3><i className="fa fa-rupee"></i><span>10</span>
                                                    <span className="rechrsnglsidebar_plan"><small>Plan</small> B</span></h3><p>Per order only (No hidden charges)</p>
                                                </div>
                                            </div>
                                            <p className="termconditions_text">*<a href="/TermsCondition">T&amp;C</a> apply.</p>
                                            <button type="submit" className="btn btn-primary" onClick={() => clickToggleLoginPopup(true)}>Get Started</button>
                                        </div>
                                        <div className="researchsinglepagecat_grid">
                                            <div className="researchsinglepagecat_group">
                                                <h3>Categories</h3>
                                                <ul className="researchsinglepagecat_list">
                                                    <li className="active"><a href="/Research/morning-note">Morning Note</a></li>
                                                    <li><a href="/Research/result-updates">Result Updates</a></li>
                                                    <li><a href="/Research/economy-updates">Economy Updates</a></li>
                                                    <li><a href="/Research/ipo-coverage">IPO Coverage</a></li>
                                                    <li><a href="/Research/company-reports">Company Reports</a></li>
                                                    <li><a href="/Research/monthly-magazine">Monthly Magzines</a></li>
                                                    <li><a href="/Research/derivative-reports">Derivative reports</a></li>                                                    
                                                    <li><a href="/Research/metal-energy-watch">Metals and Energy Watch</a></li>
                                                    <li><a href="/Research/other-reports">Other Reports</a></li>
                                                </ul>
                                            </div>
                                            <div className="researchsinglepagecat_group">
                                                <h3>Recent Posts</h3>
                                                <div className="researchsinglepagercntpost_list">
												{ recentPost ? recentPost.map((row,index)=>{
													return(
												<div className="researchsinglepagercntpost_group" key={index}>
                                                        <a href={'/Research/'+row.category+'/'+row.title.replaceAll(' ','-')} className="researchsinglepagercntpost_panel">
                                                          
                                                            <div className="researchsinglepagercntpost_text">
                                                                <p> {row.title}</p>
                                                                <span> {dayname[new Date(row.date).getDay()]+","+row.date.split('-')[2]+" "+months[row.date.split('-')[1]-1]+" "+row.date.split('-')[0]}</span>
                                                            </div>
                                                        </a>
												</div>
												)})
                                                    :''
												}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p>Note* <a href="https://www.moneysukh.com/disclaimer">  Please refer to disclaimer</a></p>
                        </div>
                    </div>
                    <LoginPopup show={show} ref={childRef} />
                </div>
            </section></>:''}
            {data=="Not Found" && <div>{(researchPostRedirect.includes(pathName+"/") ) ? <img src={ResearchNotFOUND} alt={ResearchNotFOUND} style={{width:"100%"}}/>
                :<h1>404 Page Not found</h1>}</div>}
        </>
    )
}

export default Morningnote;